import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import "./i18n";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";

if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}
ReactDOM.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <App />
    </SoftUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
